const initialState = {
  books: [],
  status: {
    filterFeature: false,
    editMode: false,
    searchText: '',
    editInfo: {
      id: null,
      name: '',
      author: '',
      thumbnail: '',
      price: '',
      rating: '',
      featured: false,
    },
  },
};

export default initialState;
